/* Reveal grid — cards rise in row by row; [data-count] numbers count up once revealed. */
if (!customElements.get('reveal-grid')) {
  customElements.define('reveal-grid', class extends HTMLElement {
    connectedCallback() {
      const items = [...this.querySelectorAll('[data-reveal]')];
      const reduced = document.documentElement.classList.contains('reduced-motion');
      if (reduced || !('IntersectionObserver' in window)) { items.forEach(el => el.classList.add('is-in')); return; }

      items.forEach(el => el.querySelectorAll('[data-count]').forEach(n => { n.textContent = (0).toFixed(+n.dataset.dec || 0); }));

      this.io = new IntersectionObserver(entries => {
        // Stagger cards that enter on the same row.
        let rowTop = null, stag = 0;
        entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left)
          .forEach(e => {
            const el = e.target, top = e.boundingClientRect.top;
            if (rowTop === null || Math.abs(top - rowTop) > 40) { rowTop = top; stag = 0; } else stag++;
            el.style.transitionDelay = `${stag * 0.12}s`;
            el.classList.add('is-in');
            el.querySelectorAll('[data-count]').forEach(n => this.count(n, stag * 120 + 250));
            this.io.unobserve(el);
          });
      }, { rootMargin: '0px 0px -12% 0px' });
      items.forEach(el => this.io.observe(el));
    }

    disconnectedCallback() { this.io?.disconnect(); }

    count(n, delay) {
      const target = parseFloat(n.dataset.count) || 0, dec = +n.dataset.dec || 0;
      const t0 = performance.now() + delay;
      const step = now => {
        const k = Math.min(1, Math.max(0, (now - t0) / 1400)), e = 1 - Math.pow(1 - k, 4);
        n.textContent = (target * e).toFixed(dec);
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  });
}
